<span>Saldo disponível</span>
<b>{{ balance | currencyBRL }}</b>
